module.exports = __webpack_public_path__ + "img/JP_F.1eb6cc85.png";